export default __webpack_public_path__ + "static/img3-3c907a2b3bf9f90cd4f31a26e0e0925f.png";